import { useState } from 'react';
import styled from 'styled-components';
import { userApi } from '../../../core/api/rtk-query/user.api';

const Wrap = styled.div`display: grid; gap: 16px;`;
const Section = styled.div`background: #fff; border-radius: 12px; padding: 20px; border: 1px solid #e5e8f0;`;
const Row = styled.div`display: flex; gap: 8px; align-items: center;`;
const Input = styled.input`padding: 10px 12px; border-radius: 10px; border: 1px solid #dbe3f6; background: #fff; width: 100%; box-sizing: border-box;`;
const Btn = styled.button`background: #fff; border: 1px solid #dbe3f6; color: #0b1221; padding: 8px 12px; border-radius: 10px; cursor: pointer;`;
const BtnPrimary = styled(Btn)`background: #0b68fe; color: #fff; border-color: #0b68fe;`;
const Grid2 = styled.div`display: grid; grid-template-columns: 1fr 1fr; gap: 12px;`;
const Label = styled.label`display: block; font-size: 13px; font-weight: 500; color: #465676; margin-bottom: 6px;`;
const TableWrap = styled.div`border: 1px solid #e5e8f0; border-radius: 14px; overflow: hidden; background: #fff;`;
const Table = styled.table`
  width: 100%; border-collapse: separate; border-spacing: 0; color: #0b1221;
  thead th { position: sticky; top: 0; background: #f7f9ff; color: #465676; padding: 12px; text-align: left; border-bottom: 1px solid #e5e8f0; }
  tbody td { border-bottom: 1px solid #eef1f6; padding: 12px; }
`;

export const AdminTeachersPage = () => {
  const [search, setSearch] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 25;
  
  // Загружаем всех преподавателей сразу
  const { data: teachersData, refetch } = userApi.useSearchUsersQuery({
    role: 'Teacher',
    name: search || undefined,
    pageNumber,
    pageSize,
  });
  
  const [createUser] = userApi.useCreateUserMutation();
  const [updateUser] = userApi.useUpdateUserMutation();
  const [verifyUser] = userApi.useVerifyUserMutation();
  const [deleteUser] = userApi.useDeleteUserMutation();
  
  const [formData, setFormData] = useState({
    isuNumber: 0,
    name: '',
    email: '',
    password: '',
    isuGroup: '',
  });

  const handleCreate = async () => {
    if (!formData.name || !formData.email || !formData.password || !formData.isuNumber) {
      alert('Заполните все поля');
      return;
    }
    try {
      // Создаем пользователя
      const result = await createUser({
        ...formData,
        groupIds: [],
      }).unwrap();
      
      // Устанавливаем роль Teacher
      await updateUser({
        id: result.id,
        role: 'Teacher',
      }).unwrap();
      
      // Верифицируем пользователя
      await verifyUser({ id: result.id }).unwrap();
      
      alert('Преподаватель создан и верифицирован!');
      setFormData({ isuNumber: 0, name: '', email: '', password: '', isuGroup: '' });
      refetch();
    } catch (e) {
      alert('Ошибка создания: ' + JSON.stringify(e));
    }
  };

  const handleDelete = async (id: string, name: string) => {
    if (!window.confirm(`Удалить преподавателя ${name}?`)) return;
    await deleteUser({ id }).unwrap();
    refetch();
  };

  const teachers = teachersData?.users || [];

  return (
    <Wrap>
      <h2 style={{ margin: 0 }}>Преподаватели</h2>

      <Section>
        <h4 style={{ marginTop: 0 }}>Создать преподавателя</h4>
        <Grid2>
          <div>
            <Label>ИСУ номер</Label>
            <Input type="number" value={formData.isuNumber || ''} onChange={e => setFormData({ ...formData, isuNumber: Number(e.target.value) })} />
          </div>
          <div>
            <Label>ФИО</Label>
            <Input value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
          </div>
        </Grid2>
        <Grid2 style={{ marginTop: 12 }}>
          <div>
            <Label>Email</Label>
            <Input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
          </div>
          <div>
            <Label>Пароль</Label>
            <Input type="password" value={formData.password} onChange={e => setFormData({ ...formData, password: e.target.value })} />
          </div>
        </Grid2>
        <div style={{ marginTop: 12 }}>
          <Label>Группа ИСУ (опционально)</Label>
          <Input value={formData.isuGroup} onChange={e => setFormData({ ...formData, isuGroup: e.target.value })} />
        </div>
        <Row style={{ marginTop: 16, justifyContent: 'flex-end' }}>
          <BtnPrimary onClick={handleCreate}>Создать преподавателя</BtnPrimary>
        </Row>
      </Section>

      <Section>
        <h4 style={{ marginTop: 0 }}>Поиск преподавателей</h4>
        <Row>
          <Input placeholder="Поиск по имени..." value={search} onChange={e => setSearch(e.target.value)} />
        </Row>
      </Section>

      {teachers.length > 0 && (
        <TableWrap>
          <Table>
            <thead>
              <tr>
                <th>ИСУ</th>
                <th>ФИО</th>
                <th>Email</th>
                <th>Группа</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {teachers.map((t: any) => (
                <tr key={t.id}>
                  <td>{t.isuNumber}</td>
                  <td>{t.name}</td>
                  <td>{t.email}</td>
                  <td>{t.isuGroup || '—'}</td>
                  <td>
                    <Row style={{ gap: 8 }}>
                      <Btn onClick={() => handleDelete(t.id, t.name)}>Удалить</Btn>
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrap>
      )}

      {teachersData && teachers.length === 0 && (
        <div style={{ padding: 20, textAlign: 'center', color: '#667' }}>
          Преподаватели не найдены
        </div>
      )}
    </Wrap>
  );
};
